import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import Search from 'shared/ui/Search/Search';
import FilterButton from 'shared/ui/IconButton/FilterButton';
import ExportButton from 'shared/ui/IconButton/ExportButton';
import RefreshButton from 'shared/ui/IconButton/RefreshButton';
import MoreActions from 'shared/ui/MoreActions/MoreActions';
import MoreActionsDots from 'shared/ui/MoreActions/MoreActionsDots';
import MoreActionsItem from 'shared/ui/MoreActions/MoreActionsItem';

import styles from './TableToolbar.module.scss';

export interface IExportItem {
    key: string,
    label: string,
    menuLabel?: string,
    onClick: () => void,
}

interface ITableToolbarProps {
    onSearch?: (_search: string) => void,
    searchValue?: string,
    onFilter?: () => void,
    onExport?: () => void,
    exportItems?: IExportItem[],
    onRefresh?: () => void,
    isRefreshing?: boolean,
    disabled?: boolean,
}

const TableToolbar: React.FC<ITableToolbarProps> = ({
    onSearch,
    searchValue,
    onFilter,
    onExport,
    exportItems,
    onRefresh,
    isRefreshing,
    disabled = false,
}) => {
    const hasMenu = Boolean(onSearch && (onFilter || onExport || exportItems || onRefresh));

    return (
        <div className={cn(styles.toolbar, onSearch && styles.withSearch)}>
            {onSearch && <Search onSubmit={onSearch} disabled={disabled} defaultValue={searchValue}/>}
            {onFilter && <FilterButton className={styles.button} onClick={onFilter} disabled={disabled}/>}
            {onExport && <ExportButton className={styles.button} onClick={onExport} disabled={disabled}/>}
            {exportItems && (
                <div className={styles.exportItems}>
                    <MoreActions anchor={<ExportButton className={styles.button} disabled={disabled}/>}>
                        {exportItems.map(item => (
                            <MoreActionsItem key={item.key} label={item.label} onClick={item.onClick}/>
                        ))}
                    </MoreActions>
                </div>
            )}
            {onRefresh && (
                <RefreshButton
                    className={styles.button}
                    title={t`Обновить`}
                    onClick={onRefresh}
                    isRefreshing={isRefreshing}
                    disabled={disabled}
                />
            )}
            {hasMenu && (
                <div className={cn(styles.menu, disabled && styles.menuDisabled)}>
                    <MoreActionsDots>
                        {onFilter && <MoreActionsItem key="filter" label={t`Фильтры`} onClick={onFilter}/>}
                        {onExport && <MoreActionsItem key="export" label={t`Экспорт CSV`} onClick={onExport}/>}
                        {exportItems?.map(item => (
                            <MoreActionsItem
                                key={item.key}
                                label={item.menuLabel ?? item.label}
                                onClick={item.onClick}
                            />
                        ))}
                        {onRefresh && <MoreActionsItem key="refresh" label={t`Обновить`} onClick={onRefresh}/>}
                    </MoreActionsDots>
                </div>
            )}
        </div>
    );
};

export default TableToolbar;
